import { Component, forwardRef, OnDestroy, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup, UntypedFormBuilder, ControlValueAccessor, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { CardTypeConstants } from '@uzurv/core';
import { CardType, PaymentAccount } from '@uzurv/clara';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-payment-account-selector',
  templateUrl: './payment-account-selector.component.html',
  styleUrls: ['./payment-account-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaymentAccountSelectorComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PaymentAccountSelectorComponent),
      multi: true
    }
  ]
})
export class PaymentAccountSelectorComponent implements ControlValueAccessor, OnDestroy {
  @Input() organizationRiderId: number;
  @Input() paymentAccounts: Array<PaymentAccount> = [];

  selected: PaymentAccount;
  paymentAccountForm: UntypedFormGroup;
  subscriptions: Array<Subscription> = [];

  constructor(private domSanitizer: DomSanitizer, private formBuilder: UntypedFormBuilder) {
    this.paymentAccountForm = this.formBuilder.group({
      paymentAccount: PaymentAccount
    });

    this.subscriptions.push(
      this.paymentAccountForm.valueChanges.subscribe((value) => {
        this.onChange(value.paymentAccount);
        this.onTouched();
      })
    );
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  writeValue(paymentAccount: PaymentAccount): void {
    if (paymentAccount) {
      this.paymentAccount = paymentAccount;
    }
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange: any = () => {};

  onTouched: any = () => {};

  get paymentAccount(): PaymentAccount {
    return this.paymentAccountForm.value.paymentAccount;
  }

  set paymentAccount(value: PaymentAccount) {
    this.paymentAccountForm.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  cardImageHtml(cardType: CardType): SafeHtml {
    const cardTypeCode = cardType?.code;
    let imageString = '/assets/';

    switch (cardTypeCode) {
      case CardTypeConstants.CARD_TYPE_CODE_AMEX:
        imageString += 'amex.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_DISCOVER:
        imageString += 'discover.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_MASTER_CARD:
        imageString += 'mastercard.png';
        break;

      case CardTypeConstants.CARD_TYPE_CODE_VISA:
        imageString += 'visa.png';
        break;

      default:
        imageString += 'credit.png';
        break;
    }
    return this.domSanitizer.bypassSecurityTrustUrl(imageString);
  }

  validate(_: UntypedFormControl): any {
    return this.paymentAccountForm.valid ? null : { paymentAccount: { valid: false } };
  }
}
